export const childResultsScrollAreaStyles = {
  content: {
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
  },
};
